import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue } from '../../public/utility/formValues'

class MonthlySalaryDeductionInfoDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.GetDeuctionInfo()
    }

    GetDeuctionInfo = () => {
        const { id, personID, salaryApplyID } = this.props
        Tyan.doPostEvent({
            event: 'GetDeuctionInfo',
            data: { id, personID, salaryApplyID },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { changedValues基本信息, } = this.state
        const { id, personID, salaryApplyID, onClose, onRefresh } = this.props
        Tyan.doPostEvent({
            event: 'SaveDeuctionInfo',
            data: { id, personID, salaryApplyID, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged()
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        const { list: 加扣项 } = Tyan.utility.getListItems(this, '基本信息', '加扣项')
        const p = { margin: '0px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
        return [
            { _text: '姓名', minWidth: '95%', disabled: true },
            {
                _group: '', minWidth: '95%', items: [
                    {
                        _group: '', name: '标题', minWidth: '95%', items: [
                            { _label: '科目名称', minWidth: '30%', ...p },
                            { _label: '金额', minWidth: '10%', ...p },
                            { _label: '备注', minWidth: '59%', ...p, flex: 2, },
                        ]
                    }
                ].concat(加扣项 && 加扣项.map(({ id }) => {
                    const list = { listName: '加扣项', id }
                    const 状态 = getFormValue(this, '基本信息', `加扣项[${id}].状态`)
                    return {
                        _group: '', minWidth: '95%', /* dynamicRender: true, */ items: [
                            { _text: '', name: '科目名称', list, minWidth: '30%', ...p, disabled: true },
                            { _float: '', name: '金额', list, minWidth: '10%', ...p, disabled: 状态 !== 1 },
                            { _text: '', name: '备注', list, minWidth: '59%', ...p, flex: 2, disabled: 状态 !== 1 },
                        ]
                    }
                }))
            },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, personID, salaryApplyID } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state

        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth="700"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(MonthlySalaryDeductionInfoDiv)